import template from './ecocode-trustpilot-business-unit-config.html.twig';

const {Component, Locale, State} = Shopware;
const {object} = Shopware.Utils;

Component.register('ecocode-trustpilot-business-unit-config', {
    template,
    emits: ['update:value'],
    inheritAttrs: false,
    inject: ['ecocodeTrustpilotConfigurationService'],
    props: {
        value: {
            type: Object,
            default() {
                const templates = {};
                Locale.getLocaleRegistry().forEach((key, locale) => {
                    templates[locale] = null;
                });
                return {
                    businessUnit: null,
                    templates,
                    productTemplates: object.deepCopyObject(templates),
                    useCustomTemplates: false
                };
            }
        }
    },
    data() {
        return {
            businessUnitsList: [],
            templatesList: {},
            productTemplatesList: {},
            currentValue: {
                businessUnit: null,
                templates: {},
                productTemplates: {},
                useCustomTemplates: false
            }
        };
    },

    computed: {
        businessUnitOptions() {
            if (!this.businessUnitsList || !this.currentValue) {
                return [];
            }

            const options = [];

            this.businessUnitsList.forEach((businessUnit) => {
                if (!this.currentValue.businessUnit) {
                    this.currentValue.businessUnit = businessUnit.id;
                    this.triggerChange()
                }

                let label = `${businessUnit.displayName}`;
                if (businessUnit.companyName) {
                    label = `${businessUnit.displayName} (${businessUnit.companyName} )`;
                }

                options.push({
                    label,
                    value: businessUnit.id
                });
            });

            return options;
        },
        productInvitationState() {
            return State.getters.sendProductInvitation;
        }
    },
    created() {
        this.prepareTemplatesLocaleList();
    },
    async mounted() {
        this.isLoading = true;
        const configuration = await this.loadConfiguration();

        if (configuration === false) {
            this.$router.replace({name: 'ecocode.trustpilot.setup.connect'});
        }

        this.businessUnitsList = configuration.businessUnits;
        this.isLoading = false;

        if (this.value) {
            this.currentValue = {
                ...this.currentValue,
                ...object.deepCopyObject(this.value)
            }
        }
    },
    methods: {
        async loadConfiguration() {
            const configuration = await this.ecocodeTrustpilotConfigurationService.getBusinessUnitConfiguration();

            if (configuration.status === 'not_connected') {
                return false;
            }
            return configuration;
        },
        prepareTemplatesLocaleList() {
            const locales = Locale.getLocaleRegistry();
            locales.forEach((key, locale) => {
                if (!this.templatesList.hasOwnProperty(locale)) {
                    this.templatesList[locale] = '';
                }
                if (!this.productTemplatesList.hasOwnProperty(locale)) {
                    this.productTemplatesList[locale] = '';
                }
            });
        },
        getDefaultTemplates() {
            const templates = {};
            Locale.getLocaleRegistry().forEach((key, locale) => {
                templates[locale] = null;
            });
            return templates;
        },
        triggerChange() {
            if (this.currentValue.useCustomTemplates === false) {
                this.currentValue.templates = this.getDefaultTemplates();
                this.currentValue.productTemplates = this.getDefaultTemplates();
            }

            // wait for next render on root value change.
            this.$nextTick(() => {
                this.$emit('update:value', object.deepCopyObject(this.currentValue));
            })
        }
    }
});
